import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPreguntaActiva, setRespuesta } from "../actions";

// 1. Agregamos Spinner y Alert
import { Container, Row, Col, Button, Spinner, Alert } from "react-bootstrap";

import { Instrumento } from "./Instrumento";

// 2. Función de aleatoriedad
const obtenerSiguientePregunta = (todasLasPreguntas, respuestasActuales) => {
  const preguntasPendientes = todasLasPreguntas.filter(
    (pregunta) =>
      !respuestasActuales.some((r) => r.id_pregunta === pregunta.id_pregunta)
  );
  if (preguntasPendientes.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * preguntasPendientes.length);
  return preguntasPendientes[randomIndex].id_pregunta;
};

const PreguntaNew3 = (props) => {
  const dispatch = useDispatch();

  // 3. Estados para control de carga y errores
  const [isSaving, setIsSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [values, setValues] = useState({ seleccionada: 0, evaluar: 0 });

  const preguntaActiva = useSelector((state) => state.preguntaActiva);
  const ticket = useSelector((state) => state.ticket);

  // Buscar el instrumento activo
  const _instrumento = Instrumento.find((element) => {
    return element.id_instrumento === preguntaActiva.id_instrumento;
  });

  // Buscar la pregunta activa
  const _preg = _instrumento?.preguntas.find((element) => {
    return element.id_pregunta === preguntaActiva.id_pregunta;
  });

  // LOGICA VOLVER
  const HandleClickVolver = () => {
    // Reseteamos todo al salir
    dispatch(
      setPreguntaActiva({
        id_instrumento: 0,
        id_pregunta: 0,
        contador: 0,
        //respuestas205: [], // Limpiamos el historial local
      })
    );
  };

  if (preguntaActiva.id_instrumento === 0)
    return <Navigate to="/inicio" replace={true} />;

  const HandleClick1 = (val) => {
    setValues((values) => ({
      ...values,
      seleccionada: val,
    }));
    if (errorMsg) setErrorMsg(""); // Limpiar error si selecciona otra cosa
  };

  // LOGICA SIGUIENTE (ASYNC + RANDOM)
  const HandleClickSiguiente = async () => {
    setIsSaving(true);
    setErrorMsg("");

    try {
      // 1. Guardar en API (Await)
      const _props = {
        token: "c3649ba4e3a81815",
        function: "SetRespuesta",
        params: {
          ticket: ticket.Ticket,
          id_proceso: 1,
          id_usuario: ticket.id_usuario,
          id_pregunta: preguntaActiva.id_pregunta,
          respuesta: values.seleccionada,
          respuesta_texto: "",
          respuesta_2: 0,
          respuesta_texto_2: "",
          respuesta_3: 0,
          respuesta_texto_3: "",
        },
      };

      await dispatch(setRespuesta(_props));

      // 2. Actualizar array local de respuestas (Para que funcione el random)
      const _respuesta = {
        id_pregunta: preguntaActiva.id_pregunta,
        respuesta: values.seleccionada,
      };

      const currentRespuestas = preguntaActiva.respuestas205 || [];
      const existingIndex = currentRespuestas.findIndex(
        (item) => item.id_pregunta === _respuesta.id_pregunta
      );

      let updatedRespuestas;
      if (existingIndex >= 0) {
        updatedRespuestas = currentRespuestas.map((item, index) =>
          item.id_pregunta === _respuesta.id_pregunta
            ? { ...item, ..._respuesta }
            : item
        );
      } else {
        updatedRespuestas = [...currentRespuestas, _respuesta];
      }

      // 3. Calcular siguiente ID Random
      const idSiguiente = obtenerSiguientePregunta(
        _instrumento.preguntas,
        updatedRespuestas
      );

      const nextId =
        idSiguiente !== null ? idSiguiente : preguntaActiva.id_pregunta;

      // 4. Actualizar Redux
      dispatch(
        setPreguntaActiva({
          id_instrumento: preguntaActiva.id_instrumento,
          id_pregunta: nextId,
          contador: preguntaActiva.contador + 1,
          respuestas205: updatedRespuestas, // Guardamos el historial
        })
      );

      // 5. Reset local
      setValues((values) => ({
        ...values,
        seleccionada: 0,
        instrucciones_visible: false,
      }));
    } catch (error) {
      console.error(error);
      setErrorMsg("Error al guardar la respuesta. Intente nuevamente.");
    } finally {
      setIsSaving(false);
    }
  };

  // VISTA FIN DEL TEST
  if (_instrumento.total_preguntas < preguntaActiva.contador || !_preg)
    return (
      <Container>
        <h1 className="mt-4">Fin de Test</h1>
        <hr />
        <Row>
          <Col>
            <p className="xz-texto-v ">Has finalizado este test.</p>
            <p className="xz-texto-v ">Sigue adelante !</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button className="xz-btn-pregunta" onClick={HandleClickVolver}>
              Volver al Inicio
            </Button>
          </Col>
        </Row>
      </Container>
    );

  // BOTÓN AVANZAR CON SPINNER
  const avanzar_siguiente = () => {
    if (values.seleccionada > 0)
      return (
        <Col className="text-end">
          <Button onClick={HandleClickSiguiente} disabled={isSaving}>
            {isSaving ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                Guardando...
              </>
            ) : (
              "Avanzar a Siguiente Pregunta"
            )}
          </Button>
        </Col>
      );
  };

  // Clases dinámicas para botones
  const _opcion1_class =
    values.seleccionada === 1 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion2_class =
    values.seleccionada === 2 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion3_class =
    values.seleccionada === 3 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion4_class =
    values.seleccionada === 4 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion5_class =
    values.seleccionada === 5 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";

  return (
    <Container>
      <Row>
        <Col>
          <h3 className="mt-4 xz-titulo1">
            Pregunta {preguntaActiva.contador} de {_instrumento.total_preguntas}
          </h3>
        </Col>
        <Col>
          <h3 className="mt-4 xz-titulo2 text-end">
            {_instrumento.nombre_instrumento}
          </h3>
        </Col>
      </Row>
      <hr />
      <p className="xz-pregunta4">
        A continuación encontrará afirmaciones, frente a las cuales deberá
        identificar, cuán bien lo o la describen. No hay respuestas correctas o
        incorrectas porque cada uno/a puede pensar, sentir o creer de distinta
        forma.
      </p>
      <hr />

      {/* ESTRUCTURA VISUAL ORIGINAL MANTENIDA */}
      <Row>
        {/* COLUMNA IZQUIERDA: TEXTO */}
        <Col className="col-12 col-sm-6 xz-pregunta1">
          <p className="">{_preg.texto}</p>
        </Col>

        {/* COLUMNA DERECHA: BOTONES */}
        <Col>
          <Row>
            <Col>
              <Button
                className={_opcion1_class}
                onClick={() => HandleClick1(1)}
              >
                {_preg.alt1}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion2_class}
                onClick={() => HandleClick1(2)}
              >
                {_preg.alt2}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion3_class}
                onClick={() => HandleClick1(3)}
              >
                {_preg.alt3}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion4_class}
                onClick={() => HandleClick1(4)}
              >
                {_preg.alt4}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion5_class}
                onClick={() => HandleClick1(5)}
              >
                {_preg.alt5}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <hr className="mt-5" />

      {/* MENSAJE DE ERROR (Insertado aquí para no romper estructura superior) */}
      {errorMsg && (
        <Row className="mb-3">
          <Col>
            <Alert variant="danger">{errorMsg}</Alert>
          </Col>
        </Row>
      )}

      {/* NAVEGACIÓN INFERIOR */}
      <Row>
        <Col className="col-3 text-start">
          <span
            className="xz-texto-nota"
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={HandleClickVolver}
          >
            Volver al Inicio
          </span>
        </Col>
        <Col>
          <p className="xz-texto-nota ">{avanzar_siguiente()}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default PreguntaNew3;
